import type { ImgHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/utils';
import logoFull from '@/shared/assets/logo-full.png';
import logoHorizontal from '@/shared/assets/logo-horizontal.png';
import logoMark from '@/shared/assets/logo-mark.png';

export type LogoVariant = 'full' | 'horizontal' | 'mark';

const SOURCES: Record<LogoVariant, string> = {
  full: logoFull,
  horizontal: logoHorizontal,
  mark: logoMark,
};

interface LogoProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant?: LogoVariant;
  alt?: string;
}

export function Logo({ variant = 'horizontal', className, alt = 'Agatha', ...props }: LogoProps) {
  return (
    <img
      src={SOURCES[variant]}
      alt={alt}
      className={cn('block h-auto max-w-none select-none', className)}
      draggable={false}
      {...props}
    />
  );
}
